export default __webpack_public_path__ + "static/media/Metatheory-media-kit-v1.f6bb1af2.zip";